import type { BarcodeData } from '../../types';

/** One attempt at one frame. Must never throw, or a single bad frame ends the read. */
export type Pdf417Decoder = {
  /** Reported in decode telemetry so a poor decode rate can be attributed to a decoder. */
  readonly name: string;
  decode(frame: ImageData): Promise<BarcodeData | null>;
};

export type DecoderProbe = {
  readonly name: string;
  /** Resolves null when this decoder cannot run here — the caller then tries the next one. */
  create(): Promise<Pdf417Decoder | null>;
};

/** AAMVA payloads are latin1 bytes carrying the RS/FS separators AAMVAParser splits on, so the mapping must be 1:1. */
export const latin1Bytes = (text: string): Uint8Array =>
  Uint8Array.from(text, (character) => character.charCodeAt(0) & 0xff);

export const latin1Text = (bytes: Uint8Array): string =>
  Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
